import { Component } from '@angular/core';
import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
  selector: 'app-cookie-policy',
  standalone: false,
  templateUrl: './cookie-policy.component.html',
  styleUrl: './cookie-policy.component.scss',
})
export class CookiePolicyComponent {
  lastUpdated = '02 February 2026';

  constructor(private consent: CookieConsentService) {}

  clearConsent() {
    this.consent.clearConsent();
    // optional: show a toast/snackbar
  }
}
